<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Acknowledgements</p>
<p class="noindent">I would like to thank editors Whitney Tarella and Darcy Mahan and the staff at The History Press for giving this book a home. Writers cannot exist in a vacuum and must rely on friends to give them advice, assistance and a shoulder to cry on. I would like to thank Bernadette Peck, the website <a href="http://Murderpedia.org" target="_blank">Murderpedia.org</a>, Caryl Hopson, Susan Perkins, Woody Sins, the Herkimer County Historical Society and the Fulton County History website. I’d also like to thank my mother and father, Milton Lee and Charlene Webster, as well as my wife, Kelly Webster, and my children, Ashley, Jakob and Stephanie, for their patience, understanding and love.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgement.vue?59ced118